import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";
import RelaxModel from "Base/model/RelaxModel";

export default class BaseMobileMenu2LandscapePopupContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.interactive = true;

        this.init();
        this.addActions();
        this.hide();
    }

    init() {
        this.background = this.getChildAt(0);
        this.background.alpha = 0.9;
        this.bh = this.background.height;
        /*let bW = this.background.width;
        let bH = this.background.height - 20;
        this.background.clear();
        this.background.beginFill(0x434244, 0.9);
        this.background.drawRect(-bW/2, -bH/2, bW, bH);
        this.background.endFill();*/

        this.soundButton = this.getChildByName('soundButton');
        this.soundButton.enabled = true;

        this.fastButton = this.getChildByName('fastButton');
        this.fastButton.enabled = true;

        this.soundButton.checked = EntryPoint.GameSettings.soundMute;
        this.fastButton.checked = EntryPoint.GameSettings.quickSpin;

        this.fastButton.visible = RelaxModel.availableFastSpin;
    }

    addActions() {
        this.fastButton.actions = {
            checked: {
                callback: this.onFastClick, context: this, params: true
            },
            unchecked: {
                callback: this.onFastClick, context: this, params: false
            }
        };
        this.soundButton.actions = {
            checked: {
                callback: this.onSoundClick, context: this, params: true
            },
            unchecked: {
                callback: this.onSoundClick, context: this, params: false
            }
        }
    }

    onFastClick(data) {
        EntryPoint.GameSettings.quickSpin = data;
    }

    onSoundClick(data) {
        EntryPoint.GameSettings.soundMute = data;
        EntryPoint.GameSettings.musicMute = data;
    }

    resize(data) {
        this.background.height = data;
        this.background.y = -this.background.height;
    }

    switch() {
        if (this.visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }
}